L.Control.BetterScale = L.Control.extend({
  options: {
    position: "bottomleft",
    maxWidth: 250,
    metric: !0,
    imperial: !1,
    updateWhenIdle: !1,
  },
  onAdd: function (t) {
    this._map = t;
    var e = "leaflet-control-better-scale",
      i = L.DomUtil.create("div", e),
      n = this.options,
      s = L.DomUtil.create("div", e + "-ruler", i);
    L.DomUtil.create("div", e + "-ruler-block " + e + "-upper-first-piece", s),
      L.DomUtil.create(
        "div",
        e + "-ruler-block " + e + "-upper-second-piece",
        s
      ),
      L.DomUtil.create(
        "div",
        e + "-ruler-block " + e + "-lower-first-piece",
        s
      ),
      L.DomUtil.create(
        "div",
        e + "-ruler-block " + e + "-lower-second-piece",
        s
      );
    return (
      this._addScales(n, e, i),
      (this.ScaleContainer = i),
      t.on(n.updateWhenIdle ? "moveend" : "move", this._update, this),
      t.whenReady(this._update, this),
      i
    );
  },
  onRemove: function (t) {
    t.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
  },
  _addScales: function (t, e, i) {
    (this._iScale = L.DomUtil.create("div", e + "-label-div", i)),
      (this._iScaleLabel = L.DomUtil.create("div", e + "-label", this._iScale)),
      (this._iScaleFirstNumber = L.DomUtil.create(
        "div",
        e + "-label " + e + "-first-number",
        this._iScale
      )),
      (this._iScaleSecondNumber = L.DomUtil.create(
        "div",
        e + "-label " + e + "-second-number",
        this._iScale
      ));

    (this._iZoom = L.DomUtil.create("div", e + "-zoom-div", i)),
      (this._iZoomLabel = L.DomUtil.create("div", e + "-zoom", this._iZoom));
  },
  _update: function () {
    var t = this._map.getBounds();
    (e = t.getCenter().lat),
      (i = 6378137 * Math.PI * Math.cos((e * Math.PI) / 180)),
      (n = (i * (t.getNorthEast().lng - t.getSouthWest().lng)) / 180),
      (o = this._map.getSize()),
      (s = this.options),
      (a = 0);
    o.x > 0 && (a = n * (s.maxWidth / o.x)), this._updateScales(s, a);
  },
  _updateScales: function (t, e) {
    t.metric && e && this._updateMetric(e),
      t.imperial && e && this._updateImperial(e);
  },
  _updateMetric_old: function (t) {
    var e = this._getRoundNum(t);
    (this._iScale.style.width = this._getScaleWidth(e / t) + "px"),
      (this._iScaleLabel.innerHTML = 1e3 > e ? e + " m" : e / 1e3 + " km");
  },
  _updateMetric: function (t) {
    var e,
      i,
      n,
      o,
      s,
      v,
      a = t,
      z = this._map.getZoom();
    (r = this._iScaleFirstNumber),
      (h = this._iScaleSecondNumber),
      (l = this._iScale),
      (u = this._iScaleLabel);
    zoom = this._iZoomLabel;
    (u.innerHTML = "0"),
      a > 500
        ? ((e = a / 1000),
          (i = this._getRoundNum(e)),
          (o = this._getRoundNum(e / 2)),
          (l.style.width = this._getScaleWidth(i / e) + "px"),
          (r.innerHTML = o),
          (zoom.innerHTML = this._getZoomScale(z)),
          (h.innerHTML = i + "km"))
        : ((n = this._getRoundNum(a)),
          (s = this._getRoundNum(a / 2)),
          (l.style.width = this._getScaleWidth(n / a) + "px"),
          (r.innerHTML = s),
          (h.innerHTML = n + "m"));
  },
  _updateImperial: function (t) {
    var e,
      i,
      n,
      o,
      s,
      a = 3.2808399 * t,
      r = this._iScaleFirstNumber,
      h = this._iScaleSecondNumber,
      l = this._iScale,
      u = this._iScaleLabel;
    zoom = this._iZoomLabel;
    (u.innerHTML = "0"),
      a > 2640
        ? ((e = a / 5280),
          (i = this._getRoundNum(e)),
          (o = this._getRoundNum(e / 2)),
          (l.style.width = this._getScaleWidth(i / e) + "px"),
          (r.innerHTML = o),
          (h.innerHTML = i + "mi"))
        : ((n = this._getRoundNum(a)),
          (s = this._getRoundNum(a / 2)),
          (l.style.width = this._getScaleWidth(n / a) + "px"),
          (r.innerHTML = s),
          (h.innerHTML = n + "ft"));
  },
  _getScaleWidth: function (t) {
    return Math.round(this.options.maxWidth * t) - 10;
  },
  _getRoundNum: function (t) {
    if (t >= 2) {
      var e = Math.pow(10, (Math.floor(t) + "").length - 1),
        i = t / e;
      return (
        (i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : 1), e * i
      );
    }
    return (Math.round(100 * t) / 100).toFixed(1);
  },
  _getZoomScale: function (z) {
    switch (z) {
      case 0:
        return "1:500000000";
      case 1:
        return "1:250000000";
      case 2:
        return "1:150000000";
      case 3:
        return "1:70000000";
      case 4:
        return "1:35000000";
      case 5:
        return "1:15000000";
      case 6:
        return "1:10000000";
      case 7:
        return "1:4000000";
      case 8:
        return "1:2000000";
      case 9:
        return "1:1000000";
      case 10:
        return "1:500000";
      case 11:
        return "1:250000";
      case 12:
        return "1:150000";
      case 13:
        return "1:70000";
      case 14:
        return "1:35000";
      case 15:
        return "1:15000";
      case 16:
        return "1:8000";
      case 17:
        return "1:4000";
      case 18:
        return "1:2000";
      case 19:
        return "1:1000";
      case 20:
        return "1:500";
      case 21:
        return "1:250";
      case 22:
        return "1:150";
      default:
        return "1:35000000";
    }
  },
});

L.control.betterscale = function (options) {
  return new L.Control.BetterScale(options);
};
